import api from './axios';

export const listar = (params = {}) => api.get('/endpoints/', { params });
export const obter = (id) => api.get(`/endpoints/${id}`);
export const criar = (data) => api.post('/endpoints/', data);
export const atualizar = (id, data) => api.patch(`/endpoints/${id}`, data);
export const rotacionarCredencial = (id) => api.post(`/endpoints/${id}/rotacionar-credencial`);
export const excluir = (id) => api.delete(`/endpoints/${id}`);
export const estatisticas = (id, dias = 30) => api.get(`/endpoints/${id}/estatisticas`, { params: { dias } });
